import { render, staticRenderFns } from "./Pin.vue?vue&type=template&id=5c970b3d&scoped=true"
import script from "./Pin.vue?vue&type=script&lang=js"
export * from "./Pin.vue?vue&type=script&lang=js"
import style0 from "./Pin.vue?vue&type=style&index=0&id=5c970b3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c970b3d",
  null
  
)

export default component.exports